// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"d3e7c53d","453":"5c038977"}[chunkId] + ".chunk.js";
};